import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { getChatRoomsByReservationId } from '@/apis/resources/mobi-talk.api';
import ChatRoom from './components/ChatRoom';

const MobiForSurePage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const reservationId = searchParams.get('reservationId');
  const roomId = Number(searchParams.get('roomId'));

  useEffect(() => {
    if (!roomId && reservationId) {
      getChatRoomsByReservationId(reservationId).then((chatRooms) => {
        if (chatRooms[0]) {
          const roomId = chatRooms[0].id;
          setSearchParams({ roomId: roomId.toString() });
        }
      });
    }
  }, [roomId, reservationId, setSearchParams]);

  if (!roomId) {
    return (
      <div className='flex h-screen w-screen items-center justify-center'>
        Loading...
      </div>
    );
  }

  return (
    <div className='relative flex w-screen items-center justify-center'>
      <ChatRoom roomId={roomId} />
    </div>
  );
};

export default MobiForSurePage;
